/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from 'jquery';

/*------------------------------------*\
    ACCORDION
\*------------------------------------*/
class Accordion {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        $('.js-accordion__trigger').on('click', function(evt) {
            // if we have mulitple instances prevent handling the event more than once
            if(evt.handled !== true) {

               var triggerButton = $(this), // the trigger
                    dropDown = triggerButton.next('.js-accordion__panel'), // the associated panel
                    parentModule = $(this).parent('.accordion'); // the parent accordion


               // hide all panels other than this one
                parentModule.find('.js-accordion__panel').not(dropDown).slideUp();

               // if this triggerButton is active
                if (triggerButton.hasClass('is-active')) {
                    // remove active class
                    triggerButton.removeClass('is-active');
                } else {
                    // otherwise, remove active class from other triggers
                    parentModule.find('.js-accordion__trigger.is-active').removeClass('is-active');
                    // and add active class to this trigger
                    triggerButton.addClass('is-active');
                }

                // toggle the panel associated with the clicked trigger
                dropDown.stop(false, true).slideToggle();

                // dont handle it again
                evt.handled = true;
                evt.preventDefault();
            }

       });
    }
}

export default Accordion;
